import { RewardsService } from './model/squareup/rewards/buyer_service';
import rpc from './rpc';

const rewardClient = RewardsService.create(rpc());

export default rewardClient;
